<h2 mat-dialog-title>{{ data?.title ?? defaultContent.title }}</h2>
<mat-dialog-content>{{ data?.message ?? defaultContent.message }}</mat-dialog-content>
<mat-dialog-actions class="actions-footer">
  <button mat-raised-button color="primary" (click)="dialog.close(true)">Confirm</button>
  <button mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>
